import { _breakP } from './utils.js';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y, EffectFade } from 'swiper/modules';

export default class slider {
  constructor() {
    this.sliderResetTarget();
    this.generalSliderFunc();
    this.autoPlaySliderFunc();
    this.thumbSliderFunc();
    this.kvSliderFunc();
  }

  // キービジュアルの複数枚クロスフェード（自動再生）。.js-kvSlider。
  kvSliderFunc() {
    document.querySelectorAll('.js-kvSlider').forEach((el) => {
      if (el.querySelectorAll('.swiper-slide').length < 2) return;
      new Swiper(el, {
        modules: [EffectFade, Autoplay, A11y],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        speed: 1500,
        allowTouchMove: false,
        autoplay: { delay: 5000, disableOnInteraction: false },
        a11y: {
          enabled: true,
          prevSlideMessage: '前のスライドへ',
          nextSlideMessage: '次のスライドへ'
        }
      });
    });
  }

  // thumbSlider：メイン（クロスフェード・自動再生・ループ）＋サムネイルボタン。
  // サムネクリックで realIndex へ移動し、slideChange で is-active を同期。
  thumbSliderFunc() {
    const $thumbSlider = document.querySelectorAll('.js-thumbSlider');
    if (!$thumbSlider.length) return;

    $thumbSlider.forEach((root, i) => {
      const mainEl = root.querySelector('.thumbSlider__main');
      const thumbs = Array.from(root.querySelectorAll('.js-thumbSlider-thumb'));
      const slideCount = root.querySelectorAll('.thumbSlider__main .swiper-slide').length;
      if (!mainEl || slideCount < 2) return;

      root.classList.add('thumbSlider--' + i);

      const setActiveThumb = (realIndex) => {
        thumbs.forEach((thumb, n) => {
          const active = n === realIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      let thumbSlider;
      const sliderSet = () => {
        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            thumbSlider = new Swiper(`.thumbSlider--${i} .thumbSlider__main`, {
              modules: [EffectFade, Autoplay, A11y],
              effect: 'fade',
              fadeEffect: { crossFade: true },
              loop: true,
              speed: 1200,
              allowTouchMove: true,
              grabCursor: true,
              autoplay: { delay: 4500, disableOnInteraction: false },
              a11y: { enabled: true },
              on: {
                init: function () {
                  setActiveThumb(this.realIndex);
                },
                slideChange: function () {
                  setActiveThumb(this.realIndex);
                }
              }
            });
            obs.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px' });
        io.observe(root);
      };

      sliderSet();

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.index);
          if (thumbSlider) thumbSlider.slideToLoop(index);
        });
      });
    });
  }

  sliderResetTarget() {
    const $sliderResetTarget = document.querySelectorAll('.js-tabCont, .js-style-sect');
    if ($sliderResetTarget.length) {
      $sliderResetTarget.forEach((elm) => {
        if (elm.querySelectorAll('.swiper-wrapper').length) {
          elm.classList.add('js-sliderReset');
        }
      });
    }
  }

  generalSliderFunc() {
    const $generalSlider = document.querySelectorAll('.js-generalSlider');

    if ($generalSlider.length) {
      $generalSlider.forEach((elm, i) => {
        const elSlideLength = elm.querySelectorAll('.swiper-slide').length;
        const minSliderLength = _breakP.SP
          ? Number(elm.dataset.spMinSlides)
          : Number(elm.dataset.pcMinSlides);

        // data属性からオプションを取得
        // PC/SPで別々にloop設定（初期化時のブレークポイントで判定）
        const hasLoop = _breakP.SP
          ? elm.dataset.spLoop === 'true'
          : elm.dataset.pcLoop === 'true';
        const hasNavigation = elm.dataset.navigation === 'true';
        const hasPagination = elm.dataset.pagination === 'true';
        const hasAutoplay = elm.dataset.autoplay === 'true';

        // bullets を Swiper 標準ではなく独自ドットで出すケース（loop の複製対策）。
        // ドットは実カード数ぶんだけ存在し、realIndex を実数で割った余りでアクティブ同期する。
        const $dots = elm.querySelectorAll('.js-generalSliderDots .generalSlider__dot');
        const dotCount = $dots.length;
        const useCustomDots = dotCount > 0;
        const syncDots = (sw) => {
          if (!useCustomDots) return;
          const active = sw.realIndex % dotCount;
          $dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === active));
        };

        const slideInit = () => {
          const imgArr = elm.querySelectorAll('.swiper-slide img');
          imgArr.forEach((img) => {
            if (img.classList.contains('lazy')) {
              img.setAttribute('src', img.dataset.src);
              img.classList.remove('lazy');
            }
          });

          elm.classList.add('generalSlider--' + i);

          // loop 時はスライドが少ないと Swiper が loop を無効化するため、JS でスライドを
          // 循環複製して最低数を確保する（EJS では複製しない＝非スライダー時に余分が出ない）。
          // ドットは複製前の実カード数のままなので realIndex % dotCount で正しく同期する。
          let realSlideCount = 0;
          if (hasLoop) {
            const wrapper = elm.querySelector('.swiper-wrapper');
            const originals = wrapper ? Array.from(wrapper.children) : [];
            if (wrapper && originals.length) {
              realSlideCount = originals.length;
              // 本来のスライドに実インデックスを付与（読み上げを実枚数で行うため）
              originals.forEach((slide, idx) => { slide.dataset.generalSliderIndex = String(idx); });
              const spvPc = Number(elm.dataset.pcSlidesPerView) || 1;
              const spvSp = Number(elm.dataset.spSlidesPerView) || 1;
              const minForLoop = Math.ceil(Math.max(spvPc, spvSp)) * 2;
              // centeredSlides で左右に隣接カードを出す場合、複製が「元枚数の整数倍」でないと
              // ループ時の前後カードの並び順が崩れる（例: 4枚→6枚だと中央の両脇が同一カードになる）。
              // minForLoop 以上 かつ 元枚数の整数倍 になるまで複製する。
              for (let n = 0; wrapper.children.length < minForLoop || wrapper.children.length % originals.length !== 0; n++) {
                const clone = originals[n % originals.length].cloneNode(true);
                // 複製分は支援技術から隠す（内容が二重に読まれないように）。
                // data-general-slider-index は複製元の値を cloneNode で引き継ぐ（ラベルを複製元と揃える）。
                clone.dataset.generalSliderClone = 'true';
                clone.setAttribute('aria-hidden', 'true');
                clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
                wrapper.appendChild(clone);
              }
            }
          }

          let generalSlider;
          let sliderInitialized = false;

          // 使用するモジュールを動的に設定
          const modules = [A11y];
          if (hasNavigation) modules.push(Navigation);
          if (hasPagination && !useCustomDots) modules.push(Pagination);
          if (hasAutoplay) modules.push(Autoplay);

          const swiperOptions = {
            modules,
            loop: hasLoop,
            slidesPerView: elm.dataset.spSlidesPerView,
            spaceBetween: Number(elm.dataset.spSpaceBetween),
            speed: 2000,
            simulateTouch: true,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            centeredSlides: elm.dataset.spCenterMode === 'on',
            breakpoints: {
              768: {
                slidesPerView: elm.dataset.pcSlidesPerView,
                spaceBetween: Number(elm.dataset.pcSpaceBetween),
                centeredSlides: elm.dataset.pcCenterMode === 'on'
              }
            },
            a11y: {
              enabled: true,
              prevSlideMessage: '前のスライドへ',
              nextSlideMessage: '次のスライドへ',
              paginationBulletMessage: '{{index}}枚目のスライドを表示'
            },
            on: {
              init: function () {
                setAriaHiddenForDuplicateSlides(this);
                syncDots(this);
              },
              slideChange: function () {
                setAriaHiddenForDuplicateSlides(this);
                syncDots(this);
              }
            }
          };

          // loop有効時のみloopedSlidesを設定（複製後の枚数で）
          if (hasLoop) {
            swiperOptions.loopedSlides = elm.querySelectorAll('.swiper-slide').length;
          }

          // Pagination設定（カスタムドット使用時は Swiper 標準ページャは無効）
          if (hasPagination && !useCustomDots) {
            swiperOptions.pagination = {
              el: `.generalSlider--${i} .swiper-pagination`,
              type: 'bullets',
              clickable: true
            };
          }

          // Navigation設定
          if (hasNavigation) {
            swiperOptions.navigation = {
              nextEl: `.generalSlider--${i} .js-generalSliderNext`,
              prevEl: `.generalSlider--${i} .js-generalSliderPrev`
            };
          }

          // Autoplay設定
          if (hasAutoplay) {
            swiperOptions.autoplay = {
              delay: 4000,
              disableOnInteraction: false
            };
          }

          const setAriaHiddenForDuplicateSlides = (swiper) => {
            if (!hasLoop) return;
            swiper.slides.forEach((slide) => {
              if (slide.classList.contains('swiper-slide-duplicate') || slide.dataset.generalSliderClone === 'true') {
                slide.setAttribute('aria-hidden', 'true');
              } else {
                slide.removeAttribute('aria-hidden');
              }
              // Swiper は複製込みの総数で "X / 6" と付けるため、実枚数・実インデックスで上書き。
              // 複製分も複製元と同じ番号にする。
              const realIdx = Number(slide.dataset.generalSliderIndex);
              if (realSlideCount && !Number.isNaN(realIdx)) {
                slide.setAttribute('aria-label', `${realIdx + 1} / ${realSlideCount}`);
              }
            });
          };

          const sliderSet = () => {
            const intersectionCallback = (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && !sliderInitialized) {
                  generalSlider = new Swiper(`.generalSlider--${i} .swiper`, swiperOptions);
                  sliderInitialized = true;
                }
              });
            };
            const io = new IntersectionObserver(intersectionCallback, { rootMargin: '0px 0px' });
            io.observe(elm);
          };

          sliderSet();

          // カスタムドットのクリックで該当カードへ（loop 対応に slideToLoop）
          if (useCustomDots) {
            $dots.forEach((dot, idx) => {
              dot.addEventListener('click', () => {
                if (generalSlider) generalSlider.slideToLoop(idx);
              });
            });
          }

          const targetNode = elm.closest('.js-sliderReset');
          if (targetNode) {
            const mutationCallback = (mutationsList) => {
              mutationsList.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                  if (targetNode.classList.contains('is-active')) {
                    if (!generalSlider || generalSlider.destroyed) {
                      sliderSet();
                    }
                  } else if (generalSlider && !generalSlider.destroyed) {
                    generalSlider.destroy(true, true);
                    sliderInitialized = false;
                  }
                }
              });
            };
            const mo = new MutationObserver(mutationCallback);
            mo.observe(targetNode, { attributes: true });
          }
        };

        const slideDisable = () => {
          elm.classList.add('generalSlider--disableMode');
        };

        elSlideLength >= minSliderLength ? slideInit() : slideDisable();
      });
    }
  }

  autoPlaySliderFunc() {
    const $autoPlaySlider = document.querySelectorAll('.js-autoPlaySlider');

    if ($autoPlaySlider.length) {
      $autoPlaySlider.forEach((elm) => {
        const i = [].slice.call($autoPlaySlider).indexOf(elm);
        const elSlideLength = elm.querySelectorAll('.swiper-slide').length;
        const minSliderLength = _breakP.SP
          ? Number(elm.dataset.spMinSlides)
          : Number(elm.dataset.pcMinSlides);
        const onlyDevice = elm.dataset.onlyDevice || '';
        const dir = elm.dataset.dir || 'off';

        const slideInit = () => {
          const imgArr = elm.querySelectorAll('.swiper-slide img');
          if (imgArr.length) {
            imgArr.forEach((img) => {
              if (img.classList.contains('lazyload')) {
                img.setAttribute('src', img.dataset.src);
                img.classList.remove('lazyload');
                img.setAttribute('loading', 'lazy');
              }
            });
          }

          elm.classList.add('autoPlaySlider--' + i);
          const container = elm.querySelector('.swiper-container');
          container.setAttribute('id', `auto-slider-${i}`);

          let autoPlaySlider;
          let sliderInitialized = false;
          let originalCount = 0;

          const sliderSet = () => {
            const intersectionCallback = (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && !sliderInitialized) {
                  // ループ安定のためスライドを複製（複製分は支援技術から完全に隠す）
                  const wrapper = elm.querySelector('.swiper-wrapper');
                  const originalSlides = Array.from(wrapper.querySelectorAll(':scope > .swiper-slide'));
                  originalCount = originalSlides.length;
                  originalSlides.forEach((slide, idx) => {
                    slide.setAttribute('data-slide-index', idx);
                    slide.setAttribute('data-original', '');
                  });
                  for (let set = 0; set < 2; set++) {
                    originalSlides.forEach((slide) => {
                      const clone = slide.cloneNode(true);
                      clone.removeAttribute('data-original');
                      clone.removeAttribute('role');
                      clone.removeAttribute('aria-roledescription');
                      clone.removeAttribute('aria-label');
                      clone.setAttribute('aria-hidden', 'true');
                      wrapper.appendChild(clone);
                    });
                  }

                  const customSpeed = elm.dataset.speed ? Number(elm.dataset.speed) : 4000;
                  autoPlaySlider = new Swiper(`.autoPlaySlider--${i} .swiper-container`, {
                    modules: [Autoplay, Pagination, A11y],
                    loop: true,
                    autoplay: { delay: 1, disableOnInteraction: false },
                    pagination: elm.dataset.pagination === 'on' ? {
                      el: `.autoPlaySlider--${i} .swiper-pagination`,
                      type: 'bullets',
                      clickable: true
                    } : false,
                    loopAdditionalSlides: elSlideLength,
                    slidesPerView: 'auto',
                    spaceBetween: Number(_breakP.SP ? elm.dataset.spSpaceBetween : elm.dataset.pcSpaceBetween),
                    speed: customSpeed,
                    simulateTouch: true,
                    allowTouchMove: false,
                    centeredSlides: (_breakP.SP ? elm.dataset.spCenterMode : elm.dataset.pcCenterMode) === 'on',
                    direction: dir === 'on' ? 'vertical' : 'horizontal',
                    breakpoints: {
                      768: {
                        spaceBetween: Number(elm.dataset.pcSpaceBetween),
                        centeredSlides: elm.dataset.pcCenterMode === 'on'
                      }
                    },
                    on: {
                      init: function () {
                        setAriaHiddenForDuplicateSlides(this);
                      },
                      slideChange: function () {
                        setAriaHiddenForDuplicateSlides(this);
                      }
                    },
                    a11y: { enabled: true }
                  });
                  sliderInitialized = true;
                }
              });
            };

            const io = new IntersectionObserver(intersectionCallback, { rootMargin: '0px 0px' });
            io.observe(elm);
          };

          const setAriaHiddenForDuplicateSlides = (swiper) => {
            swiper.slides.forEach((slide) => {
              if (slide.hasAttribute('data-original')) {
                slide.removeAttribute('aria-hidden');
                const idx = Number(slide.getAttribute('data-slide-index'));
                slide.setAttribute('aria-label', `${idx + 1} of ${originalCount}`);
              } else {
                slide.setAttribute('aria-hidden', 'true');
                slide.removeAttribute('role');
                slide.removeAttribute('aria-roledescription');
                slide.removeAttribute('aria-label');
              }
            });
          };

          sliderSet();

          const controller = elm.querySelector('.js-autoPlaySlider-btn');
          const controllerText = controller ? controller.nextElementSibling : null;
          const labelName = container.getAttribute('aria-label') || 'スライダー';
          if (controller) {
            controller.setAttribute('aria-controls', `auto-slider-${i}`);
            controller.setAttribute('aria-label', `${labelName}を止める`);
          }

          if (controller) {
            controller.addEventListener('click', () => {
              const expanded = controller.getAttribute('aria-expanded') === 'true';
              if (expanded) {
                autoPlaySlider.autoplay.stop();
                controller.setAttribute('aria-label', `${labelName}を再生する`);
                controller.setAttribute('aria-expanded', 'false');
                controller.classList.add('is-stop');
                if (controllerText) controllerText.textContent = 'START';
              } else {
                autoPlaySlider.autoplay.start();
                controller.setAttribute('aria-label', `${labelName}を止める`);
                controller.setAttribute('aria-expanded', 'true');
                controller.classList.remove('is-stop');
                if (controllerText) controllerText.textContent = 'PAUSE';
              }
            });
          }

          const targetNode = elm.closest('.js-sliderReset');
          if (targetNode) {
            const mutationCallback = (mutationsList) => {
              mutationsList.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                  if (targetNode.classList.contains('is-active')) {
                    if (!autoPlaySlider || autoPlaySlider.destroyed) {
                      sliderSet();
                    }
                  } else if (autoPlaySlider && !autoPlaySlider.destroyed && controller && controller.getAttribute('aria-expanded') === 'true') {
                    autoPlaySlider.destroy(true, true);
                    sliderInitialized = false;
                  }
                }
              });
            };

            const mo = new MutationObserver(mutationCallback);
            mo.observe(targetNode, { attributes: true });

            window.addEventListener('resize', () => {
              if (autoPlaySlider && !autoPlaySlider.destroyed && controller && controller.getAttribute('aria-expanded') === 'true') {
                autoPlaySlider.destroy(true, true);
                sliderInitialized = false;
                setTimeout(() => {
                  sliderSet();
                }, 1000);
              }
            });
          }
        };

        const slideDisable = () => {
          if (onlyDevice && ((onlyDevice === 'sp' && !_breakP.SP) || (onlyDevice === 'pc' && _breakP.SP))) {
            return;
          }
          elm.classList.add('autoPlaySlider--disableMode');
        };

        elSlideLength >= minSliderLength ? slideInit() : slideDisable();
      });
    }
  }
}
